module.exports = __webpack_public_path__ + "img/ibiki.af383651.webp";